
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import SelectProvince from '@/components/inputs/province';
import UserSelectionStoreName from '@/store/user-selection/name';
import { StyleFontWeightType, StylePositionType, StyleSizeType } from '@/ui-kit/styles/enums';
import Gutter from '@/ui-kit/components/gutter';

/**
   * @component HowItWorksStatementComponent
   *
   * @prop {String} title
   * @prop {String} description
   * @private
   */

export default {
  name: 'HowItWorksStatementComponent',
  components: {
    Typography,
    SelectProvince,
    Gutter,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      TypographyType,
      StyleFontWeightType,
      StylePositionType,
      StyleSizeType,
    };
  },
  computed: {
    currentProvince() {
      return this.$store.state[UserSelectionStoreName].currentProvince;
    },
  },
};
